"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayerImages = exports.getcontainerSource = void 0;
/* eslint-disable */
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var antd_1 = require("antd");
var small_1 = __importDefault(require("../tooltips/small"));
var mapbox_gl_1 = __importDefault(require("mapbox-gl"));
var types_1 = require("../types");
var long_1 = __importDefault(require("../tooltips/long"));
var getcontainerSource = function (_a) {
    var points = _a.points, shouldCluster = _a.shouldCluster, data = _a.data, onClick = _a.onClick, toolTipType = _a.toolTipType;
    var containers = points;
    var containerId;
    var inquiriesData = data.find(function (x) { return x.pointType === types_1.PointType.Inquiries; });
    var inquiries = ((inquiriesData === null || inquiriesData === void 0 ? void 0 : inquiriesData.points) || []);
    return {
        layers: [
            {
                data: {
                    id: "containers-cluster",
                    type: "circle",
                    source: "containers",
                    filter: ["has", "point_count"],
                    paint: {
                        "circle-radius": [
                            "step",
                            ["get", "point_count"],
                            10,
                            2,
                            13,
                            10,
                            15,
                            99999,
                            20,
                        ],
                        "circle-color": "#DF9838",
                        "circle-stroke-color": "#FFFFFF",
                        "circle-stroke-width": 2,
                    },
                },
                onClick: function (e, map) {
                    var _a, _b;
                    // @ts-ignore
                    var features = map.queryRenderedFeatures(e.point, {
                        layers: ["containers-cluster"],
                    });
                    var clusterId = (_a = features[0].properties) === null || _a === void 0 ? void 0 : _a.cluster_id;
                    var point_count = (_b = features[0].properties) === null || _b === void 0 ? void 0 : _b.point_count;
                    var clusterSource = map.getSource("containers");
                    clusterSource
                        // @ts-ignore
                        .getClusterExpansionZoom(clusterId, function (err, zoom) {
                        if (err)
                            return;
                        //If the cluster cannot be expanded further - don't zoom and show the popup
                        if (zoom >= 26) {
                            // @ts-ignore
                            clusterSource.getClusterLeaves(clusterId, point_count, 0, 
                            // @ts-ignore
                            function (err, aFeatures) {
                                // showing the pop-up on the map
                                var placeholder = document.createElement("div");
                                var Content = (react_1.default.createElement(antd_1.List, { dataSource: aFeatures, renderItem: function (_a) {
                                        var properties = _a.properties;
                                        var circleColor = properties["circle-color"];
                                        var borderColor = properties["circle-stroke-color"];
                                        var borderWidth = properties["circle-stroke-width"];
                                        return (react_1.default.createElement(antd_1.List.Item, null,
                                            react_1.default.createElement(small_1.default, { data: properties.container, borderColor: borderColor, borderWidth: borderWidth, circleColor: circleColor })));
                                    } }));
                                react_dom_1.default.render(Content, placeholder);
                                new mapbox_gl_1.default.Popup({
                                    maxWidth: "450px",
                                })
                                    // @ts-ignore
                                    .setLngLat(features[0].geometry.coordinates)
                                    .setDOMContent(placeholder)
                                    .addTo(map);
                            });
                        }
                        //If the cluster can expand - Zoom into the next breakpoint
                        if (zoom < 26) {
                            // @ts-ignore
                            var center = features[0].geometry.coordinates;
                            map.easeTo({
                                center: center,
                                zoom: zoom,
                            });
                        }
                    });
                },
                onMouseEnter: function (e, map) {
                    map.getCanvas().style.cursor = "pointer";
                },
                onMouseLeave: function (e, map) {
                    map.getCanvas().style.cursor = "";
                },
            },
            {
                data: {
                    id: "containers-cluster-count",
                    type: "symbol",
                    source: "containers",
                    filter: ["has", "point_count"],
                    layout: {
                        "icon-allow-overlap": true,
                        "text-allow-overlap": true,
                        "text-field": "{point_count_abbreviated}",
                        "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                        "text-size": 12,
                    },
                    paint: { "text-color": "#FFFFFF" },
                },
            },
            {
                data: {
                    id: "containers-unclustered-point",
                    type: "circle",
                    source: "containers",
                    filter: ["!", ["has", "point_count"]],
                    paint: {
                        "circle-color": ["get", "circle-color"],
                        "circle-radius": [
                            "case",
                            ["boolean", ["feature-state", "hover"], false],
                            20,
                            6,
                        ],
                        "circle-stroke-width": ["get", "circle-stroke-width"],
                        "circle-stroke-color": ["get", "circle-stroke-color"],
                    },
                },
                onClick: function (e, map) {
                    var _a, _b, _c, _d;
                    // @ts-ignore
                    var features = map.queryRenderedFeatures(e.point, {
                        layers: ["containers-unclustered-point"],
                    });
                    // @ts-ignore
                    var center = (_b = (_a = features[0]) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.coordinates;
                    map.easeTo({
                        center: center,
                    });
                    if (onClick) {
                        onClick((_d = (_c = features[0]) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.id);
                    }
                    var toolTipData = features[0];
                    var container = JSON.parse(toolTipData.properties.container);
                    var inquiry = {};
                    if (toolTipData.properties && toolTipData.properties.inquiry) {
                        inquiry = JSON.parse(toolTipData.properties.inquiry);
                    }
                    var placeholder = document.createElement("div");
                    var circleColor = toolTipData.properties["circle-color"];
                    var borderColor = toolTipData.properties["circle-stroke-color"];
                    var borderWidth = toolTipData.properties["circle-stroke-width"];
                    var Content = (react_1.default.createElement(react_1.default.Fragment, null, toolTipType === types_1.ToolTipType.LongContainer ? (react_1.default.createElement(long_1.default, { data: container })) : (react_1.default.createElement(small_1.default, { borderColor: borderColor, borderWidth: borderWidth, circleColor: circleColor, data: container }))));
                    react_dom_1.default.render(Content, placeholder);
                    new mapbox_gl_1.default.Popup({
                        maxWidth: toolTipType === types_1.ToolTipType.LongContainer ? "540px" : "220px",
                    })
                        // @ts-ignore
                        .setLngLat(features[0].geometry.coordinates)
                        .setDOMContent(placeholder)
                        .addTo(map);
                },
                onMouseEnter: function (e, map) {
                    // @ts-ignore
                    if (e.features.length > 0) {
                        if (containerId) {
                            map.removeFeatureState({
                                source: "containers",
                                // @ts-ignore
                                id: containerId,
                            });
                        }
                        // @ts-ignore
                        containerId = e.features[0].id;
                        map.setFeatureState({
                            source: "containers",
                            // @ts-ignore
                            id: containerId,
                        }, {
                            hover: true,
                        });
                    }
                    map.getCanvas().style.cursor = "pointer";
                },
                onMouseLeave: function (e, map) {
                    if (containerId || containerId === 0) {
                        map.setFeatureState({
                            source: "containers",
                            // @ts-ignore
                            id: containerId,
                        }, {
                            hover: false,
                        });
                    }
                    containerId = null;
                    map.getCanvas().style.cursor = "";
                },
            },
            {
                data: {
                    id: "containers-highlighted-point",
                    type: "circle",
                    source: "containers",
                    filter: ["in", "id", ""],
                    paint: {
                        "circle-color": ["get", "circle-color"],
                        "circle-radius": [
                            "case",
                            ["boolean", ["feature-state", "hover"], false],
                            20,
                            6,
                        ],
                        "circle-stroke-width": 5,
                        "circle-stroke-color": ["get", "circle-stroke-color"],
                    },
                },
            },
            {
                data: {
                    id: "containers-unclustered-fillLevel",
                    type: "symbol",
                    source: "containers",
                    filter: ["!", ["has", "point_count"]],
                    layout: {
                        "icon-allow-overlap": true,
                        "text-allow-overlap": true,
                        "text-field": ["get", "text-field"],
                        "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                        "text-size": 17,
                    },
                    paint: {
                        "text-color": [
                            "case",
                            ["boolean", ["feature-state", "hover"], false],
                            ["get", "text-color"],
                            ["rgba", 0, 0, 0, 0],
                        ],
                    },
                },
            },
        ],
        sourceId: "containers",
        source: {
            type: "geojson",
            cluster: shouldCluster,
            clusterMaxZoom: 25,
            clusterRadius: 35,
            clusterProperties: {},
            generateId: true,
            data: {
                type: "FeatureCollection",
                features: containers.map(function (container) {
                    var textField = "-";
                    var textColor = "#000000";
                    var circleColor = "#9D9B9B";
                    var circlestrokeColor = "#000000";
                    var circlestrokeWidth = 0;
                    var fillLevel = Math.round(container.fillLevel || 0);
                    var containerWithInquiry = inquiries.find(function (inq) { var _a; return ((_a = inq.container) === null || _a === void 0 ? void 0 : _a.containerId) === container.containerId; });
                    // Complete with inquiries
                    if ((containerWithInquiry === null || containerWithInquiry === void 0 ? void 0 : containerWithInquiry.id) && container.completedAt) {
                        textColor = "#000000";
                        circleColor = "#FFA940";
                    }
                    // Complete without inquiries
                    else if (!(containerWithInquiry === null || containerWithInquiry === void 0 ? void 0 : containerWithInquiry.id) && container.completedAt) {
                        textColor = "#000000";
                        circleColor = "#52c41a";
                    }
                    // Pending With inquiries
                    else if ((containerWithInquiry === null || containerWithInquiry === void 0 ? void 0 : containerWithInquiry.id) && !container.completedAt) {
                        textColor = "#000000";
                        circleColor = "#ffffff";
                        circlestrokeColor = "#FFA940";
                        circlestrokeWidth = 2;
                    }
                    // Pending With out inquiries
                    else if (!(containerWithInquiry === null || containerWithInquiry === void 0 ? void 0 : containerWithInquiry.id) && !container.completedAt) {
                        textColor = "#000000";
                        circleColor = "#ffffff";
                        circlestrokeColor = "#707780";
                        circlestrokeWidth = 2;
                    }
                    // Pending with High Fill Level
                    if (fillLevel >= 96 && !container.completedAt) {
                        textColor = "#000000";
                        circleColor = "#ffffff";
                        circlestrokeColor = "#FF4D4F";
                        circlestrokeWidth = 2;
                    }
                    textField = fillLevel + "%";
                    return {
                        type: "Feature",
                        properties: {
                            id: container.id,
                            "circle-color": circleColor,
                            "text-field": textField,
                            "text-color": textColor,
                            "circle-stroke-color": circlestrokeColor,
                            "circle-stroke-width": circlestrokeWidth,
                            container: container,
                            inquiry: containerWithInquiry,
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [
                                container.location.longitude,
                                container.location.latitude,
                            ],
                        },
                    };
                }),
            },
        },
        images: exports.getLayerImages(),
    };
};
exports.getcontainerSource = getcontainerSource;
var getLayerImages = function () {
    return [
        {
            name: "image-container",
            image: "https://wastehero-prod.s3.eu-central-1.amazonaws.com/manual/map_icon_container.png",
            external: true,
        },
    ];
};
exports.getLayerImages = getLayerImages;
